import { useMemo } from 'react';
import useTransferListStore from '../store/transfer-list-store';

export function useIsResetToDefault() {
  const { config, included, excluded } = useTransferListStore();

  return useMemo(() => {
    let includedDraft: string[] = [];
    let excludedDraft: string[] = [];

    if (config?.limit) {
      includedDraft =
        config.items
          ?.filter((x) => !x.excluded)
          ?.slice(0, config.limit)
          .map((x) => x.id) ?? [];
      excludedDraft =
        config.items
          ?.slice(config.limit, config.items?.length)
          .map((x) => x.id) ?? [];
    } else {
      includedDraft =
        config?.items?.filter((x) => !x.excluded).map((x) => x.id) ?? [];
      excludedDraft =
        config?.items?.filter((x) => x.excluded).map((x) => x.id) ?? [];
    }

    return (
      includedDraft.length === included?.length &&
      excludedDraft.length === excluded?.length
    );
  }, [config, included, excluded]);
}
